import { Link } from "react-router-dom";
import { hotComics } from "@/mocks/comics";

export default function HotRecommend() {
  return (
    <section className="w-full px-4 md:px-6 py-10 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">高分好评漫画，口碑之选</p>
          </div>
          <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer">
            更多推荐 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4" data-product-shop="true">
          {hotComics.slice(0, 6).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩国漫画免费在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded-full font-medium">
                    {comic.rating}
                  </span>
                </div>
                {comic.status === "已完结" && (
                  <div className="absolute top-2 right-2">
                    <span className="bg-foreground-950/75 text-background-50 text-xs px-2 py-0.5 rounded-full">
                      已完结
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}